export default __webpack_public_path__ + "media/images/preview-5df98290371ead9a70bc3cd4733bbfa7.jpg";